function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "iep9zvcv4a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.329412 0 0 0 0 0.431373 0 0 0 0 0.478431 0 0 0 1.000000 0"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero",
  filter: "url(#iep9zvcv4a)",
  transform: "translate(-43 -293) translate(24 192) translate(19 25) translate(0 68) translate(0 8) translate(4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.297 14.271h9.551c.781 0 1.416-.635 1.416-1.415V1.438c0-.78-.635-1.415-1.416-1.415H5.297c-.78 0-1.416.635-1.416 1.415v.685H2.835V.92c0-.507-.413-.92-.92-.92h-.537c-.507 0-.92.413-.92.92v22.16c0 .507.413.92.92.92h.537c.507 0 .92-.413.92-.92V12.17h1.046v.686c0 .78.635 1.415 1.416 1.415zM4.802 1.438c0-.277.217-.495.495-.495h9.551c.274 0 .496.222.496.495v11.418c0 .273-.222.495-.496.495H5.297c-.273 0-.495-.222-.495-.495V1.438zM2.835 3.044h1.046v8.205H2.835V3.044z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.073 1.814c1.605 0 3.009.343 3.755.916.22.169.346.435.346.731v5.87c0 .412-.266.76-.635.888v.558c0 .387-.315.702-.702.702h-1.04c-.386 0-.702-.315-.702-.702v-.502H9.05v.502c0 .387-.315.702-.702.702h-1.04c-.387 0-.702-.315-.702-.702v-.558c-.368-.129-.635-.476-.635-.888v-5.87c0-.296.126-.562.346-.731.747-.573 2.15-.916 3.756-.916zM7.658 7.721c-.466 0-.843.377-.843.843 0 .466.377.844.843.844.466 0 .844-.378.844-.844 0-.466-.378-.843-.844-.843zm5.063 0c-.466 0-.844.377-.844.843 0 .466.378.844.844.844.466 0 .844-.378.844-.844 0-.466-.378-.843-.844-.843zm-2.648-4.986c-1.389 0-2.613.278-3.195.725L6.89 6.8l6.34.023c.012 0 .023-.01.023-.023V3.461c-.569-.448-1.793-.726-3.181-.726z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.551 6.99h7.096c.26 0 .472-.212.472-.472V3.171c0-.26-.212-.472-.472-.472H6.55c-.26 0-.471.212-.471.472v3.347c0 .26.211.472.471.472zm0-3.83l7.108.011v3.347c0 .007-.006.012-.012.012L6.54 6.518l.011-3.359z"
}))))))));
function Svg24BusStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24BusStop);
export default __webpack_public_path__ + "static/media/24-bus-stop.8a9dd919e81b71acd87f934f1e1fcc43.svg";
export { ForwardRef as ReactComponent };